import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';

import { getRedirect } from '../api';


const Redirect = () => {
  const params= useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const resolveAndRedirect = async () => {
      try {
        const data = await getRedirect(params.rid);
        navigate(`${data.redirect}`);
      } catch (error) {
        toast.error('Error loading your assessments. Please contact the person who provided this.');
      }
    };

    resolveAndRedirect();
  }, [params, navigate]);

  return <h1>Redirecting...</h1>;
};

export default Redirect;
